export default "__VITE_ASSET__04accb55__"